module.exports = __webpack_public_path__ + "static/new-planning-1-9ff06ea30fdc3bf2131ed1b1c54cad54.png";